import { Globe, Loader2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";
import { useI18n } from "@/lib/i18n";

export const LanguageSwitcher = ({ testid = "language-switcher" }) => {
  const { lang, setLang, languages, pending, t } = useI18n();
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger data-testid={testid} aria-label={t("language")} className="w-auto gap-2 rounded-none bg-transparent border-white/15 h-9 px-3 text-[11px] uppercase tracking-[0.15em] text-[#e3cb94]">
        {pending ? <Loader2 size={14} className="animate-spin" /> : <Globe size={14} />}
        <span>{lang}</span>
      </SelectTrigger>
      <SelectContent className="bg-[#0e0d0b] border-white/10 max-h-[60vh]">
        {languages.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>
            <span className="uppercase text-gold text-[10px] w-6 inline-block">{l.code}</span> {l.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
